import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale("es");

const reporteDeCuentasPorPagar = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []

    if (values.fechaVencimiento) {
        filtrados.push([
            { text: 'Fecha de Corte:', style: 'subheader' },
            { text: moment(values.fechaVencimiento).format('DD/MM/YYYY'), style: 'textoChico' }
        ]);
    }
    if(values.proveedores !== 0 && values.proveedores && values.proveedores.length > 0){
        let textoFiltrado = ''
        values.proveedores.map((valueProveedor) => {
            textoFiltrado += `${(valueProveedor.persona ? valueProveedor.nombre : (valueProveedor.nombre+' '+valueProveedor.apellidoPaterno+' '+valueProveedor.apellidoMaterno)) + valueProveedor.razonSocial + " - " + valueProveedor.rfc}\n`
            return null
        })
        filtrados.push([
            {text: 'Proveedores:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }
    
    let grupos = [];
    let grupoActual = [];

    for (const factura of values.facturas) {
        const esFacturaPrincipal = factura.folio && moment(factura.fechaFactura, "DD/MM/YYYY", true).isValid();

        if (esFacturaPrincipal) {
            if (grupoActual.length > 0) {
                grupos.push(grupoActual);
            }
            grupoActual = [factura];
        } else {
            grupoActual.push(factura);
        }
    }
    if (grupoActual.length > 0) {
        grupos.push(grupoActual);
    }
    
    grupos.sort((a, b) => {
        const fechaA = moment(a[0].fechaFactura, "DD/MM/YYYY").toDate();
        const fechaB = moment(b[0].fechaFactura, "DD/MM/YYYY").toDate();
        return fechaA - fechaB;
    });

    const facturasPorMoneda = {};

    grupos.forEach(grupo => {
        const cabeza = grupo[0];
        const monedaKey = cabeza.moneda || 'Sin Moneda';
        
        if (!facturasPorMoneda[monedaKey]) {
            facturasPorMoneda[monedaKey] = [];
        }
        facturasPorMoneda[monedaKey].push(...grupo);
    });

    const tablasDinamicas = [];

    let granTotalImporte = 0;
    let granTotalPagado = 0;
    let granTotalSaldo = 0;

    Object.keys(facturasPorMoneda).forEach((moneda) => {
        const facturasDeEstaMoneda = facturasPorMoneda[moneda];

        // Variables para totales locales
        let totalImporte = 0;
        let totalPagado = 0;
        let totalSaldo = 0;

        // Mapeo de filas
        const filasTabla = facturasDeEstaMoneda.map((valueFactura) => {
            const properties = valueFactura.colorStyle ? { background: valueFactura.colorStyle } : {}
            
            const esFacturaPrincipal = valueFactura.folio && moment(valueFactura.fechaFactura, "DD/MM/YYYY", true).isValid();
            if (esFacturaPrincipal) {
                totalImporte += valueFactura.totalPagar || 0;
                totalPagado += valueFactura.totalPagado || 0;
                totalSaldo += valueFactura.saldo || 0;

                return [
                    { text: valueFactura.folio, style: 'textoTabla', alignment: 'left' },
                    { text: valueFactura.fechaFactura, style: 'textoTabla', alignment: 'center' },
                    { text: [ valueFactura.proveedor, valueFactura.proveedorRfc ? { text: '\n' + valueFactura.proveedorRfc, style: 'rfcTabla' } : '' ], style: 'textoTabla', alignment: 'left' },
                    { text: isNaN(valueFactura.fechaVencimiento) ? moment(valueFactura.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L') : valueFactura.fechaVencimiento, style: 'textoTabla', alignment: 'center' },
                    { text: dineroDisabledMask(valueFactura.totalPagar), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueFactura.totalPagado), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueFactura.saldo), style: 'textoTabla', alignment: 'right' },
                    { text: valueFactura.estado, ...properties, style: 'textoTabla', alignment: 'left' },
                ];
            } else {

                return [
                    { text: '', style: 'textoTabla', alignment: 'center' }, 
                    { text: valueFactura.fechaFactura, style: 'textoTabla', alignment: 'center' }, // Cantidad
                    { text: valueFactura.proveedor, style: 'textoTabla' }, //descripcion del insumo
                    { text: dineroDisabledMask(valueFactura.totalPagar), style: 'textoTabla', alignment: 'right' }, // Precio unitario o total insumo
                    { text: dineroDisabledMask(valueFactura.totalPagado), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueFactura.saldo), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueFactura.estado), style: 'textoTabla', alignment: 'left' }, // ID del insumo
                    { text: '', style: 'textoTabla' }, 
                ];
            }
        });

        granTotalImporte += totalImporte;
        granTotalPagado += totalPagado;
        granTotalSaldo += totalSaldo;

        // Agregar fila de Totales si hay montos
        if (totalImporte > 0 || totalPagado > 0 || totalSaldo > 0) {
            filasTabla.push([
                { text: 'Totales (' + moneda + '):', style: 'totalesTabla', alignment: 'left', colSpan: 4 }, // Abarca Folio, Fecha, Proveedor, Vencimiento
                {}, {}, {},
                { text: dineroDisabledMask(totalImporte), style: 'totalesTabla', alignment: 'right' },
                { text: dineroDisabledMask(totalPagado), style: 'totalesTabla', alignment: 'right' },
                { text: dineroDisabledMask(totalSaldo), style: 'totalesTabla', alignment: 'right' },
                { text: '', style: 'totalesTabla' } 
            ]);
        }

        tablasDinamicas.push(
            // Título de la moneda
            { text: `Moneda: ${moneda}`, style: 'monedaTitle', margin: [0, 10, 0, 5] },
            
            // La tabla
            {
                style: 'tableExample',
                table: {
                    widths: ['8%', '15%', '23%', '10%', '10%', '10%', '10%', '14%'],
                    headerRows: 1,
                    layout: { defaultBorder: true },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Proveedor', style: 'tituloTabla' },
                            { text: 'Vencimiento', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                            { text: 'Estado', style: 'tituloTabla' },
                        ],
                        ...filasTabla
                    ]
                },
                layout: {
                    fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff",
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 1,
                    vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                    hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                    vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } }
                }
            }
        );
    });

    tablasDinamicas.push({
        style: 'tableExample',
        table: {
            widths: ['8%', '15%', '23%', '10%', '10%', '10%', '10%', '14%'],
            body: [[
                { text: 'GRAN TOTAL:', style: 'totalesTabla', alignment: 'left', colSpan: 4, fillColor: '#aaaaaa' },
                {}, {}, {},
                { text: dineroDisabledMask(granTotalImporte), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                { text: dineroDisabledMask(granTotalPagado), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                { text: dineroDisabledMask(granTotalSaldo), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                { text: '', style: 'totalesTabla', fillColor: '#aaaaaa' },
            ]]
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
    });

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              {
      //							rowSpan: 3,
                                  border: [false, false, false, false],
                                  image: 'logo',
                                  fit: [80, 80] 
                                  //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                              },
                              {
                              //	rowSpan: 2,
                                  border: [false, false, false, false],
                                  table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                        [
                                            { 
                                            text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                            style: "tableHeader" 
                                            }
                                        ],
                                        [
                                          {
                                            text: "R.F.C: "+empresa.rfc,
                                            style: "textoChico",
                                            alignment: "center",
                                          },
                                        ],
                                        [
                                            {
                                              text: empresa.calle+' '+
                                                    empresa.numeroCalle+' '+
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                        [
                                            {
                                              text: empresa.colonia.tipoAsentamiento+' '+
                                              empresa.colonia.nombre+' C.P. '+
                                              empresa.colonia.cp+' '+
                                              empresa.municipio.nombre+' '+
                                              empresa.estado.abreviatura+' '+
                                              empresa.pais.abreviatura+' '
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                          [{text: 'REPORTE DE CUENTAS POR PAGAR', style: 'tableHeader'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Desglose:', style: 'subheader', alignment: 'center'}],
                                          [{text: values.detalle ? 'Si' : 'No', style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                          ]
      
                      ]
                  },
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                        defaultBorder: false,
                        },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
                  
              },
              ...tablasDinamicas,
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
               monedaTitle: {
                fontSize: 12,
                bold: true,
            },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              rfcTabla: {
                  fontSize: 6,
                  italics: true,
                  color: '#666666'
              },
                totalesTabla: {
                    fontSize: 8,
                    bold: true,
                    italics: false,
                    fillColor: '#cccccc',
                }
          },
          pageSize: 'LETTER',
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};


export default reporteDeCuentasPorPagar;
